// eslint-disable-next-line import/prefer-default-export
export const getOutcome = (defaultOutcome, override) => {
  if (override) {
    return { outcome: override };
  }

  const fromQuery = new URLSearchParams(window.location.search).get(defaultOutcome);
  if (fromQuery) {
    return { outcome: fromQuery };
  }

  return {};
};
